/* istanbul ignore file */

import Keycloak from 'keycloak-js';
import { APIENV, getCustomiserState } from '@europrocurement/l2d-domain';

export const keycloakConfig = {
    ...APIENV.keycloak[getCustomiserState().env],
    clientId: 'back-to-digital',
};

export const keycloak = new Keycloak({
    ...APIENV.keycloak[getCustomiserState().env],
    clientId: 'back-to-digital',
});

export const updateToken = () => keycloak.updateToken(10).then(() => keycloak.token || '');
